import React, { useMemo } from 'react';
import { addWeeks, format, startOfWeek } from 'date-fns';
import { Reveal } from './Reveal';
import { EmbedForm, FormField } from './EmbedForm';
import { business, services } from '../data/site';
export function Service() {
  const fields = useMemo<FormField[]>(() => {
    const weeks = Array.from({
      length: 8
    }, (_, i) => `Week of ${format(startOfWeek(addWeeks(new Date(), i + 1), {
      weekStartsOn: 1
    }), 'MMM d')}`);
    return [{
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      autoComplete: 'name'
    }, {
      name: 'phone',
      label: 'Phone',
      type: 'tel',
      required: true,
      autoComplete: 'tel'
    }, {
      name: 'engine',
      label: 'Engine make / model',
      type: 'text',
      placeholder: 'e.g. Yamaha F150'
    }, {
      name: 'week',
      label: 'Preferred drop-off week',
      type: 'select',
      options: weeks
    }, {
      name: 'issue',
      label: 'What’s going on',
      type: 'textarea',
      placeholder: 'Symptoms, service needed, anything we should know'
    }];
  }, []);
  return <section id="service" aria-labelledby="service-title" className="w-full scroll-mt-24 bg-white" data-id="element-297" data-mp="22t9gwus945tc">
      <div className="gutter section-y" data-id="element-298" data-mp="1xv7ymc2ngaix">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-299" data-mp="1xug5d7wiyovt">
          <h2 id="service-title" className="display text-[clamp(2.75rem,5.5vw,6rem)] font-extrabold text-navy" data-id="element-300" data-mp="2bllagpinw9dj">
            Service &amp; Repair
          </h2>
          <p className="max-w-[46ch] text-ink-muted md:text-right" data-id="element-301" data-mp="1juf59uo33lhe">
            Factory-certified Yamaha and Honda technicians. Every job gets looked at — no job is too small.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4 3xl:gap-8" data-id="element-302" data-mp="1svvfo2ewfnlm">
          {services.map((s, i) => <li key={s.title} className={s.featured ? 'sm:col-span-2' : ''} data-id="element-303" data-mp="1nvqy09298mtt" data-mpi={i}>
              <Reveal delay={Math.min(i, 5) * 0.04} className="h-full" data-id="element-304" data-mp="349z8h59r35p3">
                <article className="group flex h-full flex-col overflow-hidden rounded-xl bg-sand-50" data-id="element-305" data-mp="2zbpayo0jzt0b">
                  <div className={`overflow-hidden ${s.featured ? 'aspect-[16/8]' : 'aspect-[4/3]'}`} data-id="element-306" data-mp="1wyjd5y8ad21p">
                    <img src={s.image} alt={s.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-307" data-mp="21x44171ne9dh" />
                  </div>
                  <div className="flex flex-1 flex-col p-5 md:p-6" data-id="element-308" data-mp="1e8bdxr7pivqs">
                    <h3 className={`display font-bold text-navy ${s.featured ? 'text-3xl md:text-4xl' : 'text-2xl'}`} data-id="element-309" data-mp="1e5ym8mc5d70j">{s.title}</h3>
                    <p className="mt-2 text-[15px] text-ink-muted" data-id="element-310" data-mp="1n7y41guzkf4j">{s.text}</p>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>
      </div>

      <div id="book-service" className="gutter grid scroll-mt-24 gap-10 bg-navy-900 py-14 md:py-20 lg:grid-cols-[1fr_1.15fr] lg:gap-[6vw]" data-id="element-311" data-mp="ukc3yikyvsmf">
        <div className="lg:pt-6" data-id="element-312" data-mp="zharuje1f3c6">
          <h3 className="display text-5xl font-extrabold text-white md:text-6xl 3xl:text-7xl" data-id="element-313" data-mp="rzcn0s6swgfa">Book Service</h3>
          <p className="mt-5 max-w-[46ch] text-lg text-white/80" data-id="element-314" data-mp="n0jbv6ezl1ia">
            Tell us what’s going on and when you’d like to drop off. We’ll call you to confirm. Every job gets looked at; no job is too small.
          </p>
          <p className="mt-8 text-white/70" data-id="element-315" data-mp="dyjs46cl7jbn">
            Prefer to talk?{' '}
            <a href={business.tel} className="font-semibold text-water-300 underline underline-offset-4 hover:text-white" data-id="element-316" data-mp="910e97jsx8k8">
              {business.phone}
            </a>
          </p>
        </div>
        <EmbedForm embedId="onedash-form-service" fields={fields} submitLabel="Book Service" successTitle="Request received" successText="We’ll call you to confirm your drop-off." footnote="We’ll call you to confirm. Every job gets looked at; no job is too small." data-id="element-317" data-mp="3vfth2ne6amua" />
      </div>
    </section>;
}